"use client";

import { EstudioGratisLanding } from "@/components/home/estudio-gratis-landing";
import { HUBSPOT_FORMS } from "@/data/hubspot-forms";

export default function EstudioGratisPage() {
  return (
    <EstudioGratisLanding
      headerFormId={HUBSPOT_FORMS.freeStudyOrganicHeader}
      footerFormId={HUBSPOT_FORMS.freeStudyOrganicFooter}
    />
  );
}
